import { put, call, takeEvery } from "redux-saga/effects"
import { removeField } from "src/engine/repositories/resourceTypeFields"
import { showToast } from "@infotech/uikit-toasts"
import get from "lodash/get"
import { REMOVE } from "../actions/types"
import { removeError, removeSuccess } from "../actions/creators/remove"

// remove item from list saga
function* requestRemove(action) {
  const { id, refresh } = action.config

  try {
    const result = yield call(removeField, id)
    yield put(removeSuccess(action, result))
    showToast({
      type: `success`,
      message: `Поле "${get(action, `config.name`)}" успешно удалено.`,
      hideIn: 5,
    })
    refresh()
  } catch (error) {
    yield put(removeError(action, error))
  }
}

export default function* removeSaga() {
  yield takeEvery(REMOVE, requestRemove)
}
